(function ($, global, undefined) {
    var functionsToRunOnLoad = [];
    var functionsToRunOnHtmlInsert = [];
    var loaded = false;
    var doneLoading = false;
    var logConsoleDebugMessages = true;

    var Cobalt = {

        load: function () {
            if (loaded) {
                return;
            }

            Cobalt.startTime = new Date();
            loaded = true;

            var functions = functionsToRunOnLoad;
            functionsToRunOnLoad = null;

            if (functions && logConsoleDebugMessages) {
                console.debug('Initializing ' + functions.length + ' explicit functions (bad)');
            }

            // Execute each function
            for (var i = 0; i < functions.length; i++) {
                try {
                    functions[i]();
                }
                catch (e) {
                    if (Cobalt.Constants.IsDevelopment) {
                        console.log(functions[i]);
                        $.log("Error: " + e);
                        if (e && e.stack) {
                            $.log(e.stack);
                        }
                    }
                }
            }

            doneLoading = true;
            Cobalt.triggerHtmlInsert($(document));

            if (window.console && Cobalt.startTime !== undefined && logConsoleDebugMessages) {
                console.info('Cobalt initialized in ' + (new Date() - Cobalt.startTime) + 'ms');
            }
            //            }, true);
        },
        initialize: function (initFunctions) {
            console.log('Initializing..');
            //Go up each path adding their dependencies
            var extraInitializers = [];

            $.each(initFunctions, function (i, val) {
                if (val.dependency != null && val.dependency.priority != null && val.dependency.priority < val.priority) {
                    val.priority = val.dependency.priority;
                }
                Cobalt.buildDependencyTree(val, extraInitializers);
            });


            // build an array of distinct functions since a class can be
            // a dependency to multiple others
            var distinctFunctions = {};
            var distinctFunctionArray = [];
            var allFunctions = initFunctions.concat(extraInitializers);

            for (var i = 0; i < allFunctions.length; i++) {
                var fn = allFunctions[i];
                var existingFunction = distinctFunctions[fn.name];
                if (existingFunction == null || existingFunction.priority == null || existingFunction.priority > fn.priority) {
                    distinctFunctions[fn.name] = fn;
                }
            }

            // push distinct functions to an array
            for (var p in distinctFunctions) {
                distinctFunctionArray.push(distinctFunctions[p]);
            }

            // sort the distinct functions in the array based on priority
            distinctFunctionArray.sortBy(function (value) {
                return value.priority;
            });

            //Fire off the initializers
            if (distinctFunctionArray && logConsoleDebugMessages) {
                $.debug('Initializing ' + distinctFunctionArray.length + ' dependant funcs (good)');
            }

            // Run each initialize function in the proper order
            $.each(distinctFunctionArray, function (i, initializer) {
                Cobalt.profile(function () {
                    try {
                        initializer.dependency.initialize();
                    }
                    catch (e) {
                        $.error("An error occurred attempting to initialize the dependency '" + initializer.name + "'");
                        throw e;
                    }
                }, initializer.name);
            });
        },
        profile: function (func, name) {
            var start = new Date();
            func();
            var took = new Date() - start;

            if (logConsoleDebugMessages)
                console.log((name || 'Profiling took') + ': ' + took + 'ms');
        },
        runOnLoad: function (func) {
            if (!func) {
                throw "Null function set to run on load";
            }

            if (!loaded) {
                functionsToRunOnLoad.push(func);
            }
            else {
                func();
            }
        },
        runOnHtmlInsert: function (func) {
            if (!func) {
                throw "Undefined function passed to runOnHtmlInsert";
            }
            functionsToRunOnHtmlInsert.push(func);
            if (doneLoading) {
                func($(document));
            }
        },
        triggerHtmlInsert: function ($parent) {

            if (!$parent) {
                throw "Cannot pass null into triggerHtmlInsert";
            }

            for (var i = 0; i < functionsToRunOnHtmlInsert.length; i++) {
                var func = functionsToRunOnHtmlInsert[i];
                func($parent);
            }
        },
        buildDependencyTree: function (jsClass, extraInitializers) {

            if (jsClass.dependency === undefined) {
                throw 'Tried to init undefined type: ' + jsClass.name;
            }

            var priority = 99;
            var newClass = null;

            //If it has a dependent script, figure out its priority and try to go up the path
            if (jsClass.dependency.dependentScripts !== undefined) {
                var dependentScripts = jsClass.dependency.dependentScripts();
                $.each(dependentScripts, function (i, newClass) {
                    newClass.priority = newClass.priority || ((jsClass.priority || 99) - 1);
                    extraInitializers.push(newClass);
                    Cobalt.buildDependencyTree(newClass, extraInitializers);
                });
            }
        },
        newDate: function (utcEpoch) {
            ///<summary>Returns a new localized date using the time supplied, otherwise it will be set to the current time.</summary>
            ///<param name="utcEpoch">UTC epoch value</param>

            return (typeof utcEpoch === "number")
                ? new Date(utcEpoch)
                : new Date();
        },
        detectIsOnMobile: function () {
            var width = window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            // we only care about the width of the window
            // we have decided to ignore useragent
            if (width <= 1023) {
                return true;
            }
            else {
                return false;
            }
        }
    };

    global.Cobalt = Cobalt;

    // fix for when console isn't present
    if (!window.console || !console.firebug) {
        !function (w) {
            var fn, i = 0;
            if (!w.console) w.console = {};
            if (w.console.log && !w.console.debug) w.console.debug = w.console.log;
            fn = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'getFirebugElement', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'notifyFirebug', 'profile', 'profileEnd', 'time', 'timeEnd', 'trace', 'warn'];
            for (i = 0; i < fn.length; ++i) if (!w.console[fn[i]]) w.console[fn[i]] = function () { };
        }(window);
    }

    $(function () {
        Cobalt.load();
    });

})(jQuery, window || this);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.js